import { AUTHENTICATED, UNAUTHENTICATED } from "../definitions/authConstants";
import { CreateReducer } from "../../shared/utils/createReducer";
import { LocalStorage } from "../../shared/utils/LocalStorageHelpers";

interface IAuthState {
  authenticated: boolean;
  user?: string | null;
}

const initState: IAuthState = {
  authenticated: LocalStorage.getItem("USER") ? true : false,
  user: LocalStorage.getItem("USER"),
};

const authReducer = CreateReducer(initState, {
  [AUTHENTICATED](state: any, action: any) {
    const { authenticated, user } = action.payload;
    return {
      ...state,
      authenticated,
      user,
    };
  },
  [UNAUTHENTICATED](state: any, payload: any) {
    const { authenticated } = payload;
    return { ...state, authenticated };
  },
});

export default authReducer;
